import { siteDevelopmentUrl } from "../../utility/Index";

export const audienceInteractionData = {
  AudienceInteraction: {
    Title: "Audience Interaction",
    GeneralTopData: [
      "As an audience member on ESQUADIFI, you have multiple ways to engage with live events, both free and ticketed. Interacting during streams not only enhances your experience but also supports the players you enjoy watching. Below, you’ll find a guide to all the ways you can participate in live events, from chatting to sending gifts, and how to report inappropriate behaviour if needed",
    ],
    GeneralBottomData: [""],
    Steps: [
      {
        StepTitle: "Watching Events",
        Description: [
          `Join Live Streams: Navigate to the '<a href='${siteDevelopmentUrl}/dashboard'>Events</a>' section to watch ongoing streams, both free (kall-out) and ticketed.`,
        ],
      },
      {
        StepTitle: "Chat During Events",
        Description: [
          "Engage in Real-Time: Participate in live chat with other viewers and players. Always maintain respect, as inappropriate behaviour could lead to removal.",
        ],
      },
      {
        StepTitle: "Sending Gifts",
        Description: [
          "Show Support: Purchase gifts using tokens to send to your favourite players during live streams.",
          "How to Send Gifts: Click the gift icon during the stream, select your gift, and confirm using your tokens.",
        ],
      },
      {
        StepTitle: "Leaderboards",
        Description: [
          "Top Supporters: Some events feature leaderboards that highlight top gift-givers, allowing you to gain visibility in the community.",
        ],
      },
      {
        StepTitle: "Reporting Inappropriate Behaviour",
        Description: [
          "Moderation: If you notice inappropriate behaviour, report the user by clicking their name and selecting 'Report.' Our moderation team will review the issue.",
        ],
      },
      {
        StepTitle: "Exclusive Event Interactions",
        Description: [
          "Special Features: In ticketed events, you may have access to extra engagement tools like polls, Q&A sessions, or special content.",
        ],
      },
    ],
  },
};
